import { ResponseService } from './response.service';
import { LocalStorageService } from './../services/local-storage.service';
import { ReplaySubject } from 'rxjs/Rx';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';

@Injectable()
export class NewsService {

    private oNews = new ReplaySubject(1);

    constructor(
        private apiService: ApiService,
        private responseService: ResponseService,
        private localStorageService: LocalStorageService
    ) { }

    clearService() {
        this.oNews = new ReplaySubject(1);
    }

    getNews() {
        let URL = '/news';
        this.apiService.get(URL).subscribe(
            (response) => {
                let messages = [];
                for (let message of response) {
                    messages.push(message);
                }
                this.oNews.next(messages);
            },
            (error) => {
                this.oNews.next(false);
            }
        );
        return this.oNews;
    }

    getHistory()
    {
        let URL = '/news/history';
        this.apiService.get(URL).subscribe(
            (response) => {
                let messages = [];
                for (let message of response) {
                    messages.push(message);
                }
                this.oNews.next(messages);
            },
            (error) => {
                this.oNews.next(false);
            }
        );
        return this.oNews;
    }

}



// WEBPACK FOOTER //
// ./src/app/services/news.service.ts